module.exports = __webpack_public_path__ + "img/previda_logo.b970e357.png";